import { useState } from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { api } from '../api.js'
import { useSessao } from '../sessao.jsx'
import { useDados, Campo, Erro, Aviso } from '../componentes/basicos.jsx'

export default function Entrar() {
  const { usuario, entrar } = useSessao()
  const local = useLocation()
  const { dados: provedores } = useDados('/auth/provedores')

  const [email, setEmail] = useState('')
  const [senha, setSenha] = useState('')
  const [erro, setErro] = useState(null)
  const [enviando, setEnviando] = useState(false)

  if (usuario) return <Navigate to={local.state?.de ?? '/'} replace />

  async function enviar(evento) {
    evento.preventDefault()
    setEnviando(true)
    setErro(null)
    try {
      await entrar(email, senha)
    } catch (e) {
      setErro(e)
    } finally {
      setEnviando(false)
    }
  }

  return (
    <div className="app" style={{ paddingBottom: 0, justifyContent: 'center' }}>
      <main className="conteudo" style={{ maxWidth: 420 }}>
        <div className="pilha" style={{ alignItems: 'center', marginBottom: 8 }}>
          <img src="/icone.svg" alt="" width="64" height="64" />
          <h1>Controle de Veículos</h1>
        </div>

        <form className="cartao pilha" onSubmit={enviar}>
          <Campo rotulo="E-mail">
            <input type="email" value={email} autoComplete="username" required
                   onChange={(e) => setEmail(e.target.value)} />
          </Campo>

          <Campo rotulo="Senha">
            <input type="password" value={senha} autoComplete="current-password" required
                   onChange={(e) => setSenha(e.target.value)} />
          </Campo>

          <Erro erro={erro} />

          <button type="submit" className="botao-principal botao-largo" disabled={enviando}>
            {enviando ? 'Entrando…' : 'Entrar'}
          </button>
        </form>

        <Recuperar emailInicial={email} />

        {(provedores?.google || provedores?.microsoft) && (
          <div className="cartao pilha">
            <span className="rotulo-secao">Ou entre com</span>
            {provedores.google && (
              <a className="botao botao-largo" href="/api/auth/oidc/google">Google</a>
            )}
            {provedores.microsoft && (
              <a className="botao botao-largo" href="/api/auth/oidc/microsoft">Microsoft</a>
            )}
          </div>
        )}
      </main>
    </div>
  )
}

/**
 * Recuperação de senha. A resposta do servidor é sempre a mesma, exista ou não a
 * conta — não revelamos quais e-mails estão cadastrados —, então a mensagem aqui
 * também é genérica de propósito.
 */
function Recuperar({ emailInicial }) {
  const [aberto, setAberto] = useState(false)
  const [email, setEmail] = useState(emailInicial ?? '')
  const [mensagem, setMensagem] = useState(null)
  const [erro, setErro] = useState(null)
  const [enviando, setEnviando] = useState(false)

  async function pedir(evento) {
    evento.preventDefault()
    setEnviando(true)
    setErro(null)
    try {
      const r = await api.post('/auth/recuperar-senha', { email })
      setMensagem(r.mensagem)
    } catch (e) {
      setErro(e)
    } finally {
      setEnviando(false)
    }
  }

  if (!aberto) {
    return (
      <button type="button" className="botao-fantasma botao-largo"
              onClick={() => setAberto(true)}>
        Esqueci minha senha
      </button>
    )
  }

  return (
    <form className="cartao pilha" onSubmit={pedir}>
      <span className="rotulo-secao">Recuperar acesso</span>

      <Campo rotulo="Seu e-mail" dica="Enviamos um link para você definir uma senha nova.">
        <input type="email" value={email} required autoComplete="username"
               onChange={(e) => setEmail(e.target.value)} />
      </Campo>

      <Erro erro={erro} />
      {mensagem && <Aviso tipo="ok">{mensagem}</Aviso>}

      <div className="linha">
        <button type="submit" className="botao-principal crescer" disabled={enviando}>
          {enviando ? 'Enviando…' : 'Enviar link'}
        </button>
        <button type="button" className="botao-fantasma" onClick={() => setAberto(false)}>
          Voltar
        </button>
      </div>
    </form>
  )
}
